import { Stack, Divider, Title, MultiSelect } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { IconPlus } from "@tabler/icons-react"

import {
  DigestConfig,
  DigestOneTimeConfig,
} from "@costory/types/endpoints/digest"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { PreviewTree } from "@costory/front/pages/DigestV2/v3/PreviewTree"
import { useAxesQuery } from "@costory/front/queries/axes"
import { useGetTreeQuery } from "@costory/front/queries/digest"
import { formatDatasources } from "@costory/front/utils/filters"

export const DigestConfigStep3 = ({
  form,
}: {
  form: UseFormReturnType<DigestOneTimeConfig | DigestConfig>
}) => {
  const query = useAxesQuery()
  return (
    <Stack>
      <QueryWrapper query={query}>
        {({ data }) => (
          <MultiSelect
            searchable
            radius={10}
            {...form.getInputProps("columns")}
            data={formatDatasources(data)}
            clearable
            hidePickedOptions
            withCheckIcon={false}
            rightSection={<IconPlus />}
            data-intercom-target="costory-tour-digest-config-exploration-tree"
          />
        )}
      </QueryWrapper>
      <Divider />
      <Title order={5}>Preview</Title>
      <QueryWrapper
        query={useGetTreeQuery(form.values.whereClause, form.values.columns)}
      >
        {({ data }) => {
          return <PreviewTree data={data} columns={form.values.columns} />
        }}
      </QueryWrapper>
    </Stack>
  )
}
